/**
 * QueryTypeSelect Component
 * Allows user to select the type of query they want to run
 * Disables Performance History in comparison mode
 */

import 'react';

function QueryTypeSelect({ selectedType, onSelect, comparisonMode, comparisonRiders }) {
  const queryTypes = [
    {
      id: 'personal-best',
      name: 'Personal Best',
      description: 'Find the fastest time for this rider at a specific hill'
    },
    {
      id: 'performance-history',
      name: 'Performance History',
      description: comparisonMode 
        ? '⚠️ Not available in comparison mode'
        : 'View all times at a hill over time with charts',
      disabled: comparisonMode
    },
    {
      id: 'tsi',
      name: 'Tom Short Index',
      description: comparisonMode && comparisonRiders && comparisonRiders.filter(r => r !== null).length > 0
        ? 'Compare total times across all common events in a year'
        : '⚠️ Requires at least one frenemy to compare',
      disabled: !comparisonMode || (comparisonMode && (!comparisonRiders || comparisonRiders.filter(r => r !== null).length === 0))
    },
    {
      id: 'bell',
      name: 'Where in the Bell',
      description: 'See where your best time landed against everyone else at one event'
    }
    // Future query types can be added here:
    // {
    //   id: 'all-times',
    //   name: 'All Times',
    //   description: 'View all recorded times for this rider'
    // },
    // {
    //   id: 'class-comparison',
    //   name: 'Class Comparison',
    //   description: 'Compare performance across different classes'
    // }
  ];

  return (
    <div className="query-type-select">
      <h2>Select Query Type</h2>
      <p className="step-description">
        Choose what you&apos;d like to analyze
      </p>

      <div className="query-type-options">
        {queryTypes.map(type => (
          <button
            key={type.id}
            className={`query-type-button ${selectedType === type.name ? 'selected' : ''} ${type.disabled ? 'disabled' : ''}`}
            onClick={() => !type.disabled && onSelect(type.name)}
            disabled={type.disabled}
          >
            <h3>{type.name}</h3>
            <p>{type.description}</p>
          </button>
        ))}
      </div>

      {queryTypes.length === 1 && (
        <p className="hint-text">
          💡 More query types coming soon!
        </p>
      )}
    </div>
  );
}

export default QueryTypeSelect;
